<template>
  <el-form class="number-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="unit">
      <template slot="label">
        单位
      </template>
      <el-input v-model="control.unit"></el-input>
    </el-form-item>
    <el-form-item prop="decimal">
      <template slot="label">
        小数
      </template>
      <el-input-number
        v-model="control.decimal"
        :step="1"
        :min="0"
        :max="10"
        size="small"
      ></el-input-number>
    </el-form-item>
    <el-form-item prop="defaultVal">
      <template slot="label">
        默认值
      </template>
      <default-val-input
        :key="control._cid || control.code"
        :cur-control="control"
        :sheet="sheet"
        :available-sheet-map="availableSheetMap"
        :value="control.defaultVal"
      ></default-val-input>
    </el-form-item>
    <el-form-item prop="hint">
      <template slot="label">
        提示
      </template>
      <el-input v-model="control.hint"></el-input>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="valueRange">
      <template slot="label">
        数值范围
      </template>
      <div>
        <el-checkbox
          :value="!_.isEmpty(control.valueRange)"
          @input="changeValueRange"
        ></el-checkbox>
      </div>
      <template v-if="!_.isEmpty(control.valueRange)">
        <el-input-number
          :value="control.valueRange[0] === null ? undefined : control.valueRange[0]"
          @input="$set(control.valueRange, 0, $event)"
          placeholder="最小值"
          :controls="false"
          :max="control.valueRange[1] === null ? Infinity : control.valueRange[1]"
          size="small"
          style="width: 40%"
        ></el-input-number>
        <span>—</span>
        <el-input-number
          :value="control.valueRange[1] === null ? undefined : control.valueRange[1]"
          @input="$set(control.valueRange, 1, $event)"
          placeholder="最大值"
          :controls="false"
          :min="control.valueRange[0] === null ? -Infinity : control.valueRange[0]"
          size="small"
          style="width: 40%"
        ></el-input-number>
      </template>
    </el-form-item>
    <el-form-item prop="showComma">
      <template slot="label">
        千分位
      </template>
      <el-checkbox v-model="control.showComma"></el-checkbox>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">
        必填
      </template>
      <el-checkbox v-model="control.required" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="disabled">
      <template slot="label">
        不可编辑
      </template>
      <el-checkbox v-model="control.disabled"></el-checkbox>
    </el-form-item>
    <el-form-item prop="main">
      <template slot="label">
        标题
      </template>
      <el-checkbox v-model="control.main" @change="checkChange($event)"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
import DefaultValInput from "../default-val-input"
export default {
  name: "number-control",
  components: {
    DefaultValInput
  },
  props: {
    control: Object,
    sheet: {
      type: Object
    },
    availableSheetMap: {
      type: Object
    }
  },
  methods: {
    changeValueRange(selected) {
      this.control.valueRange = selected ? [null, null] : []
    },
    checkChange(value) {
      this.$emit("checkboxChange", "main", value)
    }
  }
}
</script>

<style lang="scss" scoped></style>
